export default __webpack_public_path__ + "images/assets/adf42635d19adf0aca7586f8de54f3c3.svg";